webpackJsonp([223907224879692],{

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplySurveyForm = function (_Component) {
	  _inherits(ApplySurveyForm, _Component);
	
	  function ApplySurveyForm(props) {
	    _classCallCheck(this, ApplySurveyForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.loadWidget = function () {
	      if (window.document.getElementById('choicely-widget')) {
	        return _this.initializeWidget();
	      }
	
	      if (typeof window.webpackJsonp === 'function') {
	        window.webpackJsonp = null;
	      }
	
	      (0, _common.loadScript)('choicely-widget', 'https://cdn.choicely.com/widget.js?t=' + Date.now(), function () {
	        return _this.initializeWidget();
	      });
	    };
	
	    _this.state = { widget: null };
	    return _this;
	  }
	
	  ApplySurveyForm.prototype.componentDidMount = function componentDidMount() {
	    var isClient = typeof window !== 'undefined';
	    if (isClient) {
	      this.loadWidget();
	    }
	  };
	
	  ApplySurveyForm.prototype.initializeWidget = function initializeWidget() {
	    if (window.ChoicelyWidget) {
	      var params = {
	        "bid": "choicely-widget-survey-a036758a7586",
	        "sk": "ag1zfmxvdmVudGVkYXBwciULEgVCcmFuZBiAgICXx821CQwLEgZTdXJ2ZXkYgICA57CW_goM",
	        "auth": "facebook,google,email", "v": "survey"
	      };
	      this.setState({ widget: window.ChoicelyWidget.i(params) });
	    }
	  };
	
	  ApplySurveyForm.prototype.render = function render() {
	    return _react2.default.createElement('div', { id: 'choicely-widget-survey-a036758a7586', style: { maxWidth: '100%' } });
	  };
	
	  return ApplySurveyForm;
	}(_react.Component);
	
	exports.default = ApplySurveyForm;
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _applySurveyForm = __webpack_require__(95);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_applySurveyForm).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	var _button = __webpack_require__(37);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _container = __webpack_require__(28);
	
	var _container2 = _interopRequireDefault(_container);
	
	__webpack_require__(448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetStartedSteps = function GetStartedSteps() {
	  var stepsData = [{
	    title: 'Fill Next Miss form',
	    text: 'Enabling beauty pageants to work in a simpler smarter way.',
	    time: '5 minutes',
	    button: _react2.default.createElement(
	      _button2.default,
	      { color: 'gold', size: 'sm' },
	      'FILL NEXT MISS FORM'
	    )
	  }, {
	    title: 'We will contact you',
	    text: 'Once we have received your form, we will contact you under 24 hours. Together we agree the next steps and the digital tools that will be used for your business.',
	    time: '24 hours'
	  }, {
	    title: 'Next Miss receives your materials',
	    text: 'Once we have received your materials (names, images, timeline, etc) needed for your casting or voting, we are ready to go live.',
	    time: '15 minutes'
	  }, {
	    title: 'You go live',
	    text: 'We will launch your casting or voting at a time of your choosing. We provide promotion recommendations for contestants, social, online medias & TV.',
	    time: '24 hours'
	  }];
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    stepsData.map(function (_ref, i) {
	      var title = _ref.title,
	          text = _ref.text,
	          time = _ref.time,
	          button = _ref.button;
	
	      var index = i + 1;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: 'get-step-' + i,
	          className: (0, _classnames2.default)({
	            'pv5 pv6-m': true,
	            'bg-near-white': index % 2
	          })
	        },
	        _react2.default.createElement(
	          _container2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'flex' },
	            _react2.default.createElement(
	              'div',
	              { className: 'gold f90 tc mr3 mr4-m mr5-l' },
	              index
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-m justify-between flex-grow-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'mr4-m' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'f6 f5-m f4-l fw5 mt0 mb2 mb3-m mb4-l' },
	                  title
	                ),
	                _react2.default.createElement(
	                  _largeText2.default,
	                  { align: 'left' },
	                  text
	                ),
	                button
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'f8 f7-m f6-l gold fw3 nowrap i mt3 mt0-m' },
	                'under ',
	                time
	              )
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = GetStartedSteps;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getStartedSteps = __webpack_require__(287);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getStartedSteps).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionApplySurvey = __webpack_require__(290);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionApplySurvey).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainSectionLayout = __webpack_require__(29);
	
	var _mainSectionLayout2 = _interopRequireDefault(_mainSectionLayout);
	
	var _applySurveyForm = __webpack_require__(96);
	
	var _applySurveyForm2 = _interopRequireDefault(_applySurveyForm);
	
	var _pageTopBar = __webpack_require__(30);
	
	var _pageTopBar2 = _interopRequireDefault(_pageTopBar);
	
	var _icons = __webpack_require__(11);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	__webpack_require__(449);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionApplySurvey = function SectionApplySurvey() {
	  return _react2.default.createElement(
	    _pageTopBar2.default,
	    { iconName: 'scale', text: 'Get started', isGold: true },
	    _react2.default.createElement(
	      _mainSectionLayout2.default,
	      {
	        title: 'What happens when you contact Next Miss',
	        about: 'We care about our clients\' time and make sure we offer the most streamlined, transparent and predictable process possible.'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'gray tc mb4' },
	        _react2.default.createElement(_icons2.default, { icon: 'arrow-down', height: '20px', className: 'mr2 relative top07' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'f11 ' },
	          'Start by Filling the Next Miss form below'
	        )
	      ),
	      _react2.default.createElement(_applySurveyForm2.default, null)
	    )
	  );
	};
	
	exports.default = SectionApplySurvey;
	module.exports = exports['default'];

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _sectionApplySurvey = __webpack_require__(289);
	
	var _sectionApplySurvey2 = _interopRequireDefault(_sectionApplySurvey);
	
	var _getStartedSteps = __webpack_require__(288);
	
	var _getStartedSteps2 = _interopRequireDefault(_getStartedSteps);
	
	var _get_started = __webpack_require__(657);
	
	var _get_started2 = _interopRequireDefault(_get_started);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetStarted = function (_Component) {
	  _inherits(GetStarted, _Component);
	
	  function GetStarted() {
	    _classCallCheck(this, GetStarted);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  GetStarted.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Get started'
	        ),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'What happens when you contact Next Miss' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'We care about our clients\' time and make sure we offer the most streamlined, transparent and predictable process possible.' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://nextmiss.com' + _get_started2.default }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://nextmiss.com/get_started/' }),
	        _react2.default.createElement('meta', { property: 'og:image:alt', content: 'Get started - Next Miss' })
	      ),
	      _react2.default.createElement(_sectionApplySurvey2.default, null),
	      _react2.default.createElement(_getStartedSteps2.default, null)
	    );
	  };
	
	  return GetStarted;
	}(_react.Component);
	
	exports.default = GetStarted;
	module.exports = exports['default'];

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/get_started.56db788a.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-get-started-js-91ebd65eaf16d7dcd204.js